module.exports = __webpack_public_path__ + "static/img/042_2.ff6dd9b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/042_2.jpg
// module id = Lu/C
// module chunks = 1